import { useEffect, useState, useCallback } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useBuscaComposicao = ({ sqAcaoFiscal, sqItemOcorrencia }) => {
  const { request: requestComposicao, data: dataComposicao } = useApiClient();
  const [composicao, setComposicao] = useState("");
  const [sentidoOperacao, setSentidoOperacao] = useState("");

  const buscaComposicao = useCallback(() => {
    if (sqAcaoFiscal !== null && sqItemOcorrencia !== null) {
      requestComposicao(apiRoutes.fiscalizacao.ocorrencia.buscaComposicao, { sqAcaoFiscal, sqItemOcorrencia });
    }
  }, [requestComposicao, sqAcaoFiscal, sqItemOcorrencia]);

  useEffect(() => {
    if (dataComposicao) {
      setComposicao(dataComposicao?.result[0].composicao);
      setSentidoOperacao(dataComposicao?.result[0].sentidoOperacao);
    }
  }, [dataComposicao]);

  return { buscaComposicao, composicao, sentidoOperacao };
};

export default useBuscaComposicao;
